export default "/images/7138b04da6e01d9c37e00231c39f219b.avif";